import { render, staticRenderFns } from "./setup_intent_element.vue?vue&type=template&id=706bafd1&scoped=true&"
import script from "./setup_intent_element.vue?vue&type=script&lang=js&"
export * from "./setup_intent_element.vue?vue&type=script&lang=js&"
import style0 from "./setup_intent_element.vue?vue&type=style&index=0&id=706bafd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bafd1",
  null
  
)

export default component.exports